/* eslint-disable */
const localization = {
    // This is the array of lexemes found in the app
    lexemes: [
      "Get Bumble",
      "Accept All",
      "Manage Options",
      "Cookie Policy",
      "Go back",
      "Incorrect phone number",
      "© {{current_year}} Bumble | All Rights Reserved",
      "Bumble BFF",
      "Bumble Bizz",
      "Bumble Date",
      "About",
      "Ambassadors",
      "The Buzz",
      "We are using cookies. If you do not adjust your settings we assume you are ok with this.",
      "Download the App",
      "Download for Android",
      "Download for iOS",
      "We’re sorry, but we can’t find the page you were looking for.",
      "Sign In",
      "Join",
      "Join the Hive!",
      "Oops, something went wrong"
],

    // These are the common words found in the lexemes of the app
    common: {
      "day": {
            "plural": [
                  "days"
            ],
            "singular": [
                  "day"
            ]
      },
      "hour": {
            "plural": [
                  "hours"
            ],
            "singular": [
                  "hour"
            ]
      },
      "minute": {
            "plural": [
                  "minutes"
            ],
            "singular": [
                  "minute"
            ]
      },
      "month": {
            "plural": [
                  "months"
            ],
            "singular": [
                  "month"
            ]
      },
      "second": {
            "plural": [
                  "seconds"
            ],
            "singular": [
                  "second"
            ]
      },
      "year": {
            "plural": [
                  "years"
            ],
            "singular": [
                  "year"
            ]
      }
}
};

// In dev mode we extend lexemes to include the indexMap as well, in production it remains as an array
if (__DEV__) {
    // This is a map of lexeme ids to their index in the array, it's only needed during development
    const indexMap = require('./index-map').default;

    localization.indexMap = indexMap;

    Object.entries(localization.indexMap).forEach(([indexKey, indexValue]) => {
        localization.lexemes[indexKey] = localization.lexemes[indexValue];
    });
}

export default localization;
